import { instantiateElements } from '../main/core/element.js'
import { SearchBar } from '../main/elements/search-bar/index.js';
import { InjectSvg } from './inject-svg.js'
import { ShowOnScroll } from './show-on-scroll.js'
import { StopVideoOnClose } from './stop-video-on-close.js'

window.onload = async () => {
  await instantiateElements('#search', SearchBar);
  await instantiateElements('img[src$=".svg"]', InjectSvg);
  await instantiateElements('[dsfr-doc-show-on-scroll]', ShowOnScroll);
  await instantiateElements('.fr-modal', StopVideoOnClose);
};
